<template>
  <div>

    <app-warp :title='pageSet.activity&&pageSet.activity.params.title'>
      <template #app-content>
        <div style="height:100%;" class="moduleMain">
          <component :is="activeKey" :data="pageSet[activeKey]" />
        </div>
      </template>
      <template #app-sider>
        <a-radio-group v-model:value="activeKey" button-style="solid" @change="changePage" class="m-b-20 m-l-20">
          <a-radio-button value="activity">首页</a-radio-button>
          <a-radio-button value="award">中奖页</a-radio-button>
          <a-radio-button value="notWinning">未中奖页</a-radio-button>
          <a-radio-button value="write">填写实物订单</a-radio-button>
          <a-radio-button value="repeatAward">奖品被领走</a-radio-button>
        </a-radio-group>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}" :key="1">
            <template v-for="(value,index) in formCreateData" :key="value+index">
              <a-form-item :label="value.label" :help="value.help">
                <!-- 多选框 -->
                <template v-if="value.stamp=='checkbox'">
                  <a-checkbox-group :options="value.options" v-model:value="pageSet[activeKey][value.key][value.name]" />
                </template>
                <!-- 文本域 -->
                <template v-if="value.stamp=='textarea'">
                  <a-textarea v-model:value="pageSet[activeKey][value.key][value.name]" :rows="4" placeholder='请输入' />
                </template>
                <!-- 普通表单 -->
                <template v-if="value.stamp=='input'">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-input v-model:value="pageSet[activeKey][value.key][value.name]" :type="value.type" :help="value.help" :maxlength="value.maxlength" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" @click="pageSet[activeKey][value.key][value.name]=value.defaultValue">恢复默认设置</a>
                    </a-col>
                  </a-row>
                </template>
                <!-- 选择框 -->
                <template v-if="value.stamp=='select'">
                  <a-select v-model:value="pageSet[activeKey][value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                    <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                    </a-select-option>
                  </a-select>
                </template>
                <template v-if="value.stamp=='singleImage'">
                  <material :groupType='1' :image="pageSet[activeKey][value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{pageSet[activeKey][value.key][value.name]=data}" v-on:handledel="pageSet[activeKey][value.key][value.name]=''" />
                  <a href="javascript:;" v-if="value.defaultValue" @click="pageSet[activeKey][value.key][value.name]=value.defaultValue">恢复默认图</a>
                </template>
                <!-- 单选框 -->
                <template v-if="value.stamp=='radio'">
                  <a-radio-group :options="value.options" v-model:value="pageSet[activeKey][value.key][value.name]" />
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
      </template>
    </app-warp>
  </div>
</template>

<script>
import activity from "./components/activity.vue";
import award from "./components/award.vue";
import notWinning from "./components/notWinning.vue";
import repeatAward from "./components/repeatAward.vue";
import write from "./components/write.vue";
import config from "@/config";
import forms from "./form";
import modules from "./module.js"; //基础组件数据
import * as Icon from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs, watchEffect } from "vue";
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: {
    activity,
    award,
    write,
    repeatAward,
    notWinning,
    ...Icon,
  },
  name: "normal",
  props: { template_data: Object },
  setup(props, { emit }) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "activity",
    });
    const activeKey = ref("activity");
    var pageSet = reactive({
      activity: {
        style: {
          backgroundImage: "/web_base_assets/scan/join_default_bg.png",
          btnBackgroundImage: "/web_base_assets/scan/join_default_btn.png",
          backgroundColor: "#ff2419",
        },
        params: {
          is_show_user: true,
          is_show_guide: false,
          title: "扫码有礼",
        },
      },
      award: {
        style: {
          backgroundImage: "/web_base_assets/scan/award_bg_default.png",
          backgroundColor: "#FF9501",
          titleColor: "#ff3600",
          textColor: "#E81425",
        },
        params: {
          rankingKey: ["red", "point"],
          btnKey: ["cloud", "center"],
        },
      },
      write: {
        style: {
          backgroundImage: "/web_base_assets/scan/award_bg_default.png",
          backgroundColor: "#FF9501",
          titleColor: "#121212",
          labelColor: "#121212",
        },
      },
      notWinning: {
        style: {
          backgroundImage: "/web_base_assets/scan/award_bg_default.png",
          backgroundColor: "#FF9501",
          titleColor: "#ff3600",
          textColor: "#E81425",
        },
        params: {
          icon: "/web_base_assets/scan/notWinning.png",
          rankingKey: ["red", "point"],
          btnKey: ["cloud", "center"],
          copyWriting: "",
        },
      },
      repeatAward: {
        style: {
          backgroundImage: "/web_base_assets/scan/award_bg_default.png",
          backgroundColor: "#FF9501",
          titleColor: "#ff3600",
          textColor: "#E81425",
        },
        params: {
          icon: "/web_base_assets/scan/is_recovery_default.png",
          rankingKey: ["red", "point"],
          btnKey: ["cloud", "center"],
        },
      },
    });
    watchEffect(() => {
      pageSet = props.template_data;
      if (pageSet.activity&&pageSet.activity.params&&!Object.prototype.hasOwnProperty.call(pageSet.activity.params, 'is_show_guide')) {
        pageSet.activity.params.is_show_guide = false;
      }
    });
    const activeData = ref({
      is_show: false,
      title: "扫码有礼",
      wait_time: 3,
      backgroundImage: "/web_base_assets/scan/background_default.png",
      backgroundColor: "#fc8c35",
      type: "welcome",
    });
    var modelRef = ref(pageSet.items);
    const moduleIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == activeKey.value) {
          formCreateData.value = element.formItems;
        }
      });
    };
    // 模块
    const selectModule = (item) => {
      state.active = item.type;
      formCreate();
    };
    const changePage = (e) => {
      state.value = e.target.value;
      formCreate();
    };
    const initData = () => {
      formCreate();
    };
    onMounted(() => {
      initData();
    });
    const submit = () => {
      emit("submit", pageSet);
      return pageSet;
    };
     const getThumb = () => {
          // 选中首页 用于截图
        return new Promise((resolve,reject)=>{
            // 选中首页 用于截图
          activeKey.value='activity'
          var element= document.getElementById('app-subject')
          getCanvas(element).then(res=>{
              resolve(res.image)
          }).catch(()=>{
              reject(pageSet.activity.style.backgroundImage)
          })
      })
    };
    return {
      activeKey,
      pageSet,
      selectModule,
      activeData,
      formCreateData,
      ...toRefs(state),
      modelRef,
      changePage,
      moduleIndex,
      modules,
      submit,
      getThumb,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../module.less");
</style>